import { RemoteAdminData } from 'app/infrastructure/remote-data';
import { ApiResponse, Value } from 'app/types-shared';
import { endpoints } from './endpoints';
import { ExternalUrlItemWire } from './types';

export const api = {

  loadLanguageOptions: async (): Promise<Value[]> => {
    const response = await new RemoteAdminData(endpoints.languageOptions)
      .resource<ApiResponse<Value[]>>()
      .all();

    return response.data;
  },

  loadExternalUrl: async (id: number): Promise<ExternalUrlItemWire> => {
    const response = await new RemoteAdminData(endpoints.externalUrlItem)
      .resource<ApiResponse<ExternalUrlItemWire>>()
      .withId(id)
      .single();

    return response.data;
  },

  deleteExternalUrl: (id: number): Promise<void> => {
    return new RemoteAdminData(endpoints.externalUrlItem)
      .resource<void>()
      .withId(id)
      .httpDelete({});
  },

  addExternalUrl: async (externalUrl: ExternalUrlItemWire): Promise<number> => {
    const response: any = await new RemoteAdminData(endpoints.externalUrlItem)
      .resource<ApiResponse<number>>()
      .create(externalUrl, false);

    const json: ApiResponse<number> = await response.json();

    return json.data;
  },

  updateExternalUrl: async (id: number, externalUrl: ExternalUrlItemWire): Promise<number> => {
    await new RemoteAdminData(endpoints.externalUrlItem)
      .resource<void>()
      .withId(id)
      .save(externalUrl);

    return id;
  }
};
